import type { OilViscosityParameters } from "../../d";

export function underSaturatedOilViscosityCalculator(
  params: OilViscosityParameters
): {
  undersaturatedOilViscosity: number;
} {
  return {
    undersaturatedOilViscosity: 0
  };
}
